import {
  convertConditionToListArticlesVars,
  useArticleSearchCondition,
  useArticlesListApi
} from '@/common/api/modules/articles'
import { useSiteGetApi } from '@/common/api/modules/site'
import { useFirstLoading } from '@/common/api/search'
import { articleNewPath } from '@/common/app/path'
import { useSiteId } from '@/common/app/site'

import Button, { ButtonColor } from '@/components/view/atoms/button/Button'
import Area from '@/components/view/layouts/area/Area'
import Content from '@/components/view/layouts/page/Content'
import Main, { MainLayoutType } from '@/components/view/layouts/page/Main'
import PageListLoading from '@/components/view/molecules/loading/PageListLoading'
import PageListSearching from '@/components/view/molecules/loading/PageListSearching'
import NoResultGuidance from '@/components/view/molecules/search/NoResultGuidance'
import PageTitle from '@/components/view/molecules/title/PageTitle'

import AppTitleBadge, { AppTitleBadgeType } from '@/components/container/layout/AppTitleBadge'
import ArticleDiffModalProvider from '@/components/container/modal/article/ArticleDiffModalProvider'
import ArticleListTable from '@/components/container/modules/media/article/table/ArticleListTable'
import ArticleSearchConditionField from '@/components/container/modules/media/article/table/ArticleSearchConditionField'
import TitlePageInfo from '@/components/container/utils/pager/TitlePageInfo'

// 記事一覧（記事案単位）
const ArticleListPage = () => {
  const siteId = useSiteId()
  const [condition, setCondition, onUpdatePage] = useArticleSearchCondition()
  const { data: site } = useSiteGetApi({ site_id: siteId })

  const { data, isLoading, mutate } = useArticlesListApi(
    convertConditionToListArticlesVars(siteId, condition)
  )
  const isFirstLoading = useFirstLoading(isLoading)

  return (
    <ArticleDiffModalProvider>
      <Main type={MainLayoutType.FULL}>
        <PageTitle
          title='記事一覧'
          badgeNode={<AppTitleBadge type={AppTitleBadgeType.MEDIA} />}
          description='作成した記事案とバージョン履歴を一覧・管理します'
          behindNode={
            data && (
              <TitlePageInfo
                page={condition.page}
                perPage={condition.perPage}
                total={data.total}
                unit='件'
              />
            )
          }
          rightNode={
            <Button link={articleNewPath(siteId)} size='large' color={ButtonColor.PRIMARY_BRAND}>
              新規記事を追加する
            </Button>
          }
        />

        <Content>
          {isFirstLoading ? (
            <PageListLoading />
          ) : (
            <Area tableWrap noBorder>
              <ArticleSearchConditionField
                condition={condition}
                setCondition={setCondition}
                enableArticleUpload={!!site?.enable_article_upload}
              />
              {isLoading ? (
                <PageListSearching />
              ) : data?.total ? (
                <ArticleListTable
                  items={data.items}
                  condition={condition}
                  onUpdatePage={onUpdatePage}
                  total={data.total}
                  onChanged={() => mutate()}
                />
              ) : (
                <NoResultGuidance searched name='記事' />
              )}
            </Area>
          )}
        </Content>
      </Main>
    </ArticleDiffModalProvider>
  )
}

export default ArticleListPage
